import React, { createContext, useContext } from 'react';
import useNPCData from '../hooks/useNPCData';

// Create context
const NPCContext = createContext(null);

/**
 * Provider component that wraps the app and makes NPC data available to any
 * child component that calls the useNPCData hook.
 */
export const NPCProvider = ({ children }) => {
  const npcData = useNPCData();

  return (
    <NPCContext.Provider value={npcData}>
      {children}
    </NPCContext.Provider>
  );
};

/**
 * Hook that lets any component easily access the NPC data and actions
 */
export const useNPC = () => {
  const context = useContext(NPCContext);
  if (context === null) {
    throw new Error('useNPC must be used within a NPCProvider');
  }
  return context;
};
